import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Toggle from 'legacy/common/components/form/Toggle';
import PauseIcon from '../icons/PauseIcon';
import HideIcon from '../icons/HideIcon';
import { OutgoingEventProductDto } from 'api/dtos/events/products';

type TicketTogglesProps = {
  ticket: OutgoingEventProductDto;
  toggleTicketTier: (isDisabled: boolean) => void;
  toggleHideTier: () => void;
};

const TicketToggles: React.FC<TicketTogglesProps> = ({
  ticket,
  toggleTicketTier,
  toggleHideTier
}) => {
  const { t } = useTranslation(['events']);
  
  const handlePauseToggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!ticket?.isActive) {
        toggleTicketTier(false);
        return;
      }
      toggleTicketTier(true);
    },
    [ticket?.isActive, toggleTicketTier]
  );

  const handleHideToggle = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      toggleHideTier();
    },
    [toggleHideTier]
  );

  return (
    <div className="mt-4 flex flex-col gap-3">
      <div className="flex flex-row justify-between">
        <div className="flex gap-3">
          <PauseIcon />
          <span className="text-sm text-[#202020]">{t('events:pricingTiers.tierManagement.pauseTierSales')}</span>
        </div>
        <div className="ml-2">
          <Toggle isActive={!ticket?.isActive} onClick={handlePauseToggle} />
        </div>
      </div>

      <div className="flex flex-row items-center justify-between">
        <div className="flex -ml-1 gap-2">
          <HideIcon />
          <span className="text-sm text-[#202020]">
            {t('events:pricingTiers.tierManagement.hideTierFromPurchasers')}
          </span>
        </div>
        <div className="ml-2">
          <Toggle isActive={!ticket?.isVisible} onClick={handleHideToggle} />
        </div>
      </div>
    </div>
  );
};

export default TicketToggles;
